import * as React from 'react';
import { Message } from '../../../models/message';
import * as moment from 'moment';
import './style.css';

export interface Props {
    message: Message;
}

interface State {
    // [id: number]: Message;
    [id: string]: Message; //temporary fixed
}

class Indicator extends React.Component<Props, State> {
    componentDidMount() {
        setInterval(
            () => {
                this.scanToHideMessage();
            },
            1000);
    }

    componentWillReceiveProps(nextProps: Props) {
        if (this.props.message !== nextProps.message) {

            this.setState((prevState: State) => {
                return {
                    ...prevState,
                    [nextProps.message.id]: nextProps.message
                };
            });
        }
    }

    scanToHideMessage = () => {
        if (this.state !== null) {
            let messagesNeedToHide = Object.keys(this.state).map((key: string) => {

                // let messageTime = moment(key);
                let now = moment().valueOf();

                // let duration = now.diff(messageTime);
                let duration = now - parseInt(key, 0);

                if (duration < 5000) {
                    return;
                }

                return this.state[key];
            });

            messagesNeedToHide.map((item: Message) => {
                if (typeof item !== 'undefined') {

                    this.setState((prevState: State) => {

                        return {
                            ...prevState,
                            [item.id]: undefined //re-assign to undefined to hide (return null)
                        };
                    });

                }
            });
        }
    }

    render(): JSX.Element {
        if (this.state === null) {
            return (<div />);
        }

        let element = Object.keys(this.state).map((key: string) => {
            if (key === '') {
                return null;
            }

            let msgItem = this.state[key];
            if (typeof msgItem === 'undefined') {
                return null;
            }

            let divClassName = '';
            let iconClassName = '';

            if (msgItem.type === 'success') {
                divClassName = 'alert alert-success bg-success alert-dismissable animated fadeInRight';
                iconClassName = 'fa fa-check';

            } else if (msgItem.type === 'error') {
                divClassName = 'alert alert-danger bg-danger alert-dismissable animated fadeInRight';
                iconClassName = 'fa fa-times-circle';

            } else if (msgItem.type === 'warning') {
                divClassName = 'alert alert-warning bg-warning alert-dismissable animated fadeInRight';
                iconClassName = 'fa fa-warning';

            } else if (msgItem.type === 'info') {
                divClassName = 'alert alert-info alert-card bg-info alert-dismissable animated fadeInRight';
                iconClassName = 'fa fa-info-circle';
            }

            return (
                <div key={msgItem.id} className={divClassName}>
                    <div className="alert-icon"><i className={iconClassName} /></div>
                    <div className="alert-text">
                        <p dangerouslySetInnerHTML={{ __html: msgItem.message }} />
                    </div>

                </div>
            );
        });

        return (
            <div className="alert-top-setting" style={{ zIndex: 99999 }}>
                {element}
            </div>
        );
    }
}

export default Indicator;


// WEBPACK FOOTER //
// ./src/components/shared/Indicator/Indicator.tsx